import { createStyles, makeStyles, lighten } from '@material-ui/core/styles';
import { BLACK, BORDER_GRAY, GRAY } from 'constants/colors';
export default makeStyles(theme => {
  const boxSize = 10;
  const arrowBoxSize = theme.spacing(boxSize);
  const arrowTopPosition = boxSize / 4 + 1;
  return createStyles({
    arrowBox: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      borderRadius: theme.spacing(2),
      top: theme.spacing(-arrowTopPosition),
      height: arrowBoxSize,
      width: arrowBoxSize,
      background: lighten(GRAY, 0.8),
      border: `1px solid ${BORDER_GRAY}`,
      right: theme.spacing(8),
      [theme.breakpoints.down('sm')]: {
        right: theme.spacing(4)
      }
    },
    arrow: {
      fontSize: '35px',
      color: GRAY
    },
    infoList: {
      marginTop: theme.spacing(4),
      '& a': {
        color: BLACK,
        textDecoration: 'underline'
      }
    }
  });
});